export type LedgerRowTone = 'in' | 'out' | 'seed' | 'adjust' | 'none';

/**
 * 未知 kind 一律 adjust —— 兜底成 in 会让未知账目看起来像进池的钱。
 * `NONE` 是「这一期没人投注」的合成行，中性色。
 */
export function ledgerRowTone(kind: string): LedgerRowTone {
  if (kind === 'CONTRIB') return 'in';
  if (kind === 'PAYOUT') return 'out';
  if (kind === 'SEED') return 'seed';
  if (kind === 'NONE') return 'none';
  return 'adjust';
}

/**
 * 「本期进出」那一格：符号 + 绝对值。
 *
 * 0 不带符号 —— "+R$ 0" 读起来像进了一笔 0 元的账，而空期的意思是**什么都没发生**。
 * 负号用 U+2212，与列里其他行一致。
 */
export function ledgerDelta(amount: string): { sign: '+' | '−' | ''; abs: number } {
  const cents = toCents(amount);
  if (cents === 0) return { sign: '', abs: 0 };
  return { sign: cents < 0 ? '−' : '+', abs: Math.abs(cents) / 100 };
}

/** 全程整数分。钱不走浮点。 */
export function toCents(v: string): number {
  const negative = v.trimStart().startsWith('-');
  const [whole, frac = ''] = v.replace('-', '').split('.');
  const cents = Number(whole) * 100 + Number(frac.padEnd(2, '0').slice(0, 2));
  return negative ? -cents : cents;
}

/**
 * 恒等式：累计注入 + 人工调账 = 累计发出 + 累计留种 + 当前池子。
 *
 * 这条式子是透明页存在的理由 —— 它让「平台一分钱没从奖池里拿」
 * 从声明变成任何人可以自己核对的事实。**不设容差。**
 */
export function identityHolds(t: {
  in: string;
  out: string;
  seed: string;
  adjust: string;
  pot: string;
}): boolean {
  return toCents(t.in) + toCents(t.adjust)
    === toCents(t.out) + toCents(t.seed) + toCents(t.pot);
}

export function shortHash(hash: string): string {
  return hash.slice(0, 8);
}
